import React from 'react';
import {Field} from 'react-final-form';
import PropTypes from 'prop-types';

function FeatureFreeField({name, feature, tooltip}) {
    if (!feature.enable) {
        return null;
    }

    return (
        <div className="toggle-switch-wrap">
            <label className="switch">
                <Field name={name}>
                    {({input}) => (
                        <input
                            type="checkbox"
                            checked={Number(input.value) === 1}
                            onChange={(e) => {
                                input.onChange(e.target.checked ? 1 : 0);
                            }}
                        />
                    )}
                </Field>
                <span className="switch-slider round">
                    <div className="switch-slider__icon">
                        <img src="/_core/assets/themes/v5/assets/img/form3/switch-icon.svg" alt="" />
                    </div>
                </span>
            </label>
            <div className="switch-text">
                <div className="switch-label d-flex">
                    High priority
                    {tooltip}
                </div>
                {feature.showPrice && (
                    <div className="switch-price">Free</div>
                )}
            </div>
        </div>
    );
}

FeatureFreeField.propTypes = {
    name: PropTypes.string.isRequired,
    feature: PropTypes.object.isRequired,
    tooltip: PropTypes.any,
};

export default FeatureFreeField;
